<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">{{ title }}</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!savable || isWarehouseTransport || warehouseNotEq"
          @click="save"
          v-permit.SHARP_DPR_SAVE
          v-show="for800"
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn
          :disabled="!savable || warehouseNotEq"
          @click="save"
          style="margin-left: 0px"
          v-permit.SHARP_PS_SAVE
          v-show="for600"
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn @click="back">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-form class="static" v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="D/O NO"
                v-model="detail.doNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="納入指示者"
                v-model="detail.deliveryDirectorName1"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="コンテナNO"
                v-model="detail.containerNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="運送形態"
                v-model="detail.transportModeCode"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.partner')"
                v-model="detail.partnerName"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.dischargePort')"
                v-model="detail.dischargePortName"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.etd')"
                v-model="detail.etd"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.eta')"
                v-model="detail.eta"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.blNo')"
                v-model="detail.blNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.shippingAdvice.blIssueDate')"
                v-model="detail.blIssueDate"
              ></v-text-field>
            </v-flex>
            <v-flex md3 v-if="isSea" xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.shipName')"
                v-model="detail.shipName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 v-if="isAir" xs12>
              <v-text-field
                :disabled="true"
                :label="$t('B0400.labels.flightNo')"
                v-model="detail.volNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md6 sm6 xs12>
              <div required>
                <remote-autocomplete
                  :disabled="true"
                  :rules="[(v) => !!v || 'SJL納入場所 is required']"
                  label="SJL納入場所"
                  url="warehouses/kv"
                  v-model="detail.sjlWarehouseId"
                ></remote-autocomplete>
              </div>
            </v-flex>
            <v-flex md6 sm6 xs12>
              <div required>
                <remote-autocomplete
                  :rules="[(v) => !!v || '最终納入場所 is required']"
                  @change="clearPattern"
                  label="最终納入場所"
                  url="warehouses/sjl-kv"
                  v-model="detail.finallyWarehouseId"
                ></remote-autocomplete>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 sm6 xs12>
              <div required>
                <date-input
                  :required="true"
                  label="納入予定日"
                  v-model="detail.forecastDeliveryDate"
                ></date-input>
              </div>
            </v-flex>
            <v-flex md6 sm6 xs12>
              <div required>
                <v-text-field
                  :rules="[
                    (v) =>
                      /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) ||
                      `4桁の数の有効時間を入力してください`,
                  ]"
                  label="時間"
                  v-model="detail.forecastDeliveryTime"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-form ref="routingForm" v-model="routingValid">
      <routing :detail="detail" class="mt-2" ref="routing" />
    </v-form>
    <logistics-sku-detail ref="logistics"></logistics-sku-detail>
  </v-container>
</template>

<script>
import LogisticsSkuDetail from "../B0600/LogisticsSkuDetail.vue";
import Routing from "./Routing";
export default {
  components: {
    Routing,
    LogisticsSkuDetail,
  },
  data() {
    return {
      valid: false,
      routingValid: false,
      title: "配送パターン設定",
      routingItem: {},
      dialog: {
        show: false,
      },
      detailHeaders: [
        { label: "D/O NO", field: "doNo" },
        { label: "納入指示者", field: "" },
        { label: "コンテナNO", field: "containerNo" },
        { label: "運送形態", field: "transportModeCode" },
        { label: "海外取引先", field: "partnerName" },
        { label: "陸揚港", field: "dischargePortCode" },
        { label: "ETD", field: "etd" },
        { label: "ETA", field: "eta" },
        { label: "B/L NO", field: "blNo" },
        { label: "B/L発行日", field: "blIssueDate" },
        { label: "本船名", field: "shipName" },
      ],
      detail: {},
      errors: {
        DO_HAS_CONFIRMED: this.$t("B0800.messages.doConfirmed"),
        NO_CONFIG: "コンテナ枠がないので、当該納入場所を指定できません。",
        SHIPMENT_HAS_CHANGED:
          "当該データのステータスは更新されたため、画面更新してからもう一度お試してください。",
      },
    };
  },
  methods: {
    editLogisticsSku() {
      this.$refs.logistics.popup(this.detail.packages);
    },
    containerNo(item) {
      if (item.packages != null) {
        if (item.packages.filter((p) => p.containerNo != null).length > 0) {
          return item.packages.filter((p) => p.containerNo != null)[0]
            .containerNo;
        }
      }
    },
    load() {
      this.$http
        .get(`/shipping-advices/${this.$route.query.id}`)
        .then((res) => {
          this.detail = res.data;
          this.detail.containerNo = this.containerNo(this.detail);
          this.detail.forecastDeliveryTime =
            this.detail.forecastDeliveryTime &&
            [
              this.detail.forecastDeliveryTime.slice(0, 2),
              this.detail.forecastDeliveryTime.slice(3, 5),
            ].join("");
          // this.$refs.routing.jobSupplierId = this.detail.devanDirectorId

          if (this.detail.routes.length == 0) {
            //默认添加两条线路，以防止页面进来的啥都没有
            this.detail.routes.push(
              { label: "A配送業者", seq: 1 },
              { label: "B配送業者", seq: 2 }
            );
          }
          // this.detail.routes.filter(r=>r.departerCode != null && r.dischargeCode != null).length > 0 ? ''
          this.detail.routes.sort((a, b) => a.seq - b.seq);
          return this.$http.get(`/drake-sharing/shipments/${this.detail.id}`);
        })
        .then((res) => {
          this.detail = { ...this.detail, drakeSharing: res.data };
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    back() {
      this.$router.push("/B0700");
    },
    returnToList() {
      this.$message("", "保存済");
      this.$router.push("/B0700");
    },
    getConfigStatus() {
      return {};
    },
    getPatternSearchShow() {
      return true;
    },
    noCarNum() {
      for (var i = 0; i < this.detail.routes.length; i++) {
        if (
          this.detail.routes[i].deliveryModelId ===
            "CHARGE_ITEM_SUB_TYPE-CHARTER" &&
          ((!this.detail.routes[i].truckAmount &&
            this.detail.routes[i].truckAmount != 0) ||
            !this.detail.routes[i].truckTypeId)
        ) {
          return true;
        }
      }
      return false;
    },
    hasDevan() {
      for (var i = 0; i < this.detail.routes.length; i++) {
        if (
          this.detail.routes[i].departureJobId != null ||
          this.detail.routes[i].destinationJobId != null
        ) {
          return true;
        }
      }
      return false;
    },
    isValidDevan() {
      for (var i = 0; i < this.detail.routes.length; i++) {
        if (
          (this.detail.routes[i].departureJobId != null &&
            this.$refs.routing.jobSupplierId == null) ||
          (this.detail.routes[i].destinationJobId != null &&
            this.$refs.routing.jobSupplierId == null)
        ) {
          return false;
        }
      }
      return true;
    },
    save() {
      if (!this.$refs.routingForm.validate()) return;
      if (this.noCarNum()) {
        this.$message(
          "",
          "搬送サービスはチャーターの場合、トラックトン数とトラック台数は必須入力項目です"
        );
        return;
      }
      if (!this.isValidDevan()) {
        this.$message(
          "",
          "作業はデバンを選択した場合、デバン業者が入力必須項目になります。"
        );
        return;
      }
      if (this.detail.stackTypeId != "STACK_TYPE-FCL" && this.hasDevan()) {
        this.$message("", "LCL、Airの場合デバン業者を設定しないでください。");
        return;
      }
      var time = this.$insert(this.detail.forecastDeliveryTime, 0, 2, ":");
      time = this.$insert(time, 0, 5, ":");
      time = time + "00";
      this.$http
        .put(`/delivery-orders/${this.detail.id}?view=B0801`, {
          ...this.detail,
          forecastDeliveryTime: time,
          devanDirectorId: this.$refs.routing.jobSupplierId,
          ...this.getConfigStatus(),
        })
        .then(() => {
          this.$http
            .put(
              `/shipping-advices/${this.detail.doShipmentId}/changeCustomsDirector?customsDirectorId=${this.detail.customsDirectorId}`
            )
            .then(() => {
              this.returnToList();
            });
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    clearPattern() {
      this.detail.deliveryPatternCode = null;
      this.detail.routes = [
        { label: "A配送業者", seq: 1 },
        { label: "B配送業者", seq: 2 },
      ];
    },
    reUsePattern() {
      if (
        this.detail.reUsed === true &&
        this.detail.shipmentType === "FORMALSA"
      ) {
        this.$http.get(
          `/shipping-advices/${this.$route.query.id}/reuse-pattern`
        );
      }
    },
  },
  mounted() {
    this.load();
  },
  computed: {
    time() {
      var time = this.$insert(this.detail.forecastDeliveryTime, 0, 2, ":");
      time = this.$insert(time, 0, 5, ":");
      return (time = time + "00");
    },
    for800() {
      return false;
    },
    for600() {
      return true;
    },
    savable() {
      return (
        this.valid &&
        this.routingValid &&
        (this.detail.status === "納入指示済" ||
          this.detail.actStatus === "納入指示済" ||
          this.detail.status === "事前納入指示済") &&
        this.hasPattern
      );
    },
    isWarehouseTransport() {
      return (
        ((this.detail.transportModeId &&
          this.detail.transportModeId.indexOf("-AIR") !== -1) ||
          (this.detail.stackTypeId &&
            this.detail.stackTypeId.indexOf("-FCL") !== -1)) &&
        this.detail.isAllUnpaid &&
        this.detail.specialId &&
        this.detail.specialId.indexOf("WAREHOUSE_TRANSPORT") !== -1
      );
    },
    hasPattern() {
      //第一段线路的终点不为空
      return (
        this.detail &&
        this.detail.routes &&
        this.detail.routes[0].destinationWarehouseId != null
      );
    },
    isSea() {
      return this.$isSea(this.detail.transportModeId);
    },
    isAir() {
      return this.$isAir(this.detail.transportModeId);
    },
    warehouseNotEq() {
      return (
        this.detail.sjlWarehouseId !==
        (this.detail.routes &&
          this.detail.routes.length > 0 &&
          this.detail.routes[this.detail.routes.length - 1]
            .destinationWarehouseId)
      );
    },
  },
  watch: {
    "detail.finallyWarehouseId"() {
      if (this.detail.finallyWarehouseId != null) {
        this.$http
          .get(
            `/delivery-orders/${this.detail.finallyWarehouseId}/change-sjlWarehouse`
          )
          .then((res) => {
            this.$set(this.detail, "sjlWarehouseId", res.data.id);
          });
      }
    },
  },
};
</script>
